import './styles/wishlist.scss';
import WishlistModule from './wishlist.js';
import './controllers/WishlistControlController.js';
import './controllers/wishlistCountController.js';
import './directives/wishlistDirectives.js';
import './services/wishlistService.js';
export default WishlistModule;